import { useMachines } from "./use-machines";

export const useDownstreamMachines = () => {
	return useMachines({ machineTypes: ["PL1", "LantechCaseSealer", "SealProX"] });
};
